import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { Briefcase, Package, Plane, CalendarDays, Plus } from "lucide-react";
import { api } from "@/lib/api";
import { fcfa } from "@/lib/format";
import { useAuth, can } from "@/context/AuthContext";
import { EmptyState, Loader, PageTitle, StatusBadge } from "@/components/common";
import { MainImage } from "@/components/member/OpImages";

export const OP_TYPES = [
  { id: "projet", label: "Projets collectifs", icon: Briefcase },
  { id: "achat_groupe", label: "Achats groupés", icon: Package },
  { id: "voyage", label: "Voyages", icon: Plane },
  { id: "evenement", label: "Événements", icon: CalendarDays },
];
export const OP_STATUS = { brouillon: "Brouillon", soumis: "Soumis à validation", publie: "Publié", adhesions_closes: "Adhésions closes",
  en_execution: "En exécution", cloturee: "Clôturé", annulee: "Annulé", suspendue: "Suspendu" };

export default function Operations() {
  const { me } = useAuth();
  const [ops, setOps] = useState(null);
  const [type, setType] = useState("");
  useEffect(() => {
    api.get("/operations").then(({ data }) => setOps(data)).catch(() => setOps([]));
  }, []);
  const list = (ops || []).filter((o) => !type || o.type === type);
  return (
    <div className="mr-fade-up">
      <div className="flex items-start justify-between gap-3">
        <PageTitle eyebrow="Opérations" title="Opérations du club" />
        <div className="flex flex-wrap gap-2 mb-5" data-testid="commerce-links">
          {[["/app/fournisseurs", "Fournisseurs"], ["/app/evenements", "Événements"], ["/app/assistant", "Assistant IA et services"]].map(([to, l]) => (
            <Link key={to} to={to} data-testid={`link-${to.split("/").pop()}`} className="px-3 h-10 inline-flex items-center rounded-full border border-mr-border text-sm hover:border-mr-accent">{l}</Link>))}
        </div>
        {can(me, "operation:join") && <Link to="/app/operations/nouvelle" className="mr-btn-primary px-3 shrink-0" data-testid="operation-create-link"><Plus size={16} /> Proposer</Link>}
      </div>
      <div className="flex gap-2 overflow-x-auto pb-3 mb-3">
        {[{ id: "", label: "Toutes" }, ...OP_TYPES].map((t) => (
          <button key={t.id || "all"} data-testid={`operations-type-${t.id || "all"}`} onClick={() => setType(t.id)}
            className={`shrink-0 px-3 h-9 rounded-full border text-xs ${type === t.id ? "border-mr-accent text-mr-accent" : "border-mr-border text-mr-text2"}`}>{t.label}</button>))}
      </div>
      {ops === null ? <Loader /> : list.length === 0 ? <EmptyState icon={Briefcase} title="Aucune opération" text="Les opérations publiées par les porteurs apparaîtront ici." testId="operations-empty" /> : (
        <ul className="space-y-3">{list.map((o) => (
          <li key={o.id}><Link to={`/app/operations/${o.id}`} className="mr-card block p-0 overflow-hidden hover:border-mr-text2" data-testid="operation-row">
            <MainImage id={o.photo_file_ids?.[0]} className="aspect-[16/7] w-full" />
            <div className="p-5">
            <div className="flex items-center justify-between gap-3"><p className="text-xs uppercase tracking-wider text-mr-accent">{OP_TYPES.find((t) => t.id === o.type)?.label}</p><StatusBadge status={o.status} label={OP_STATUS[o.status]} /></div>
            <p className="font-display font-semibold text-lg mt-2">{o.title}</p>
            {o.summary && <p className="text-sm text-mr-text2 mt-1 line-clamp-2">{o.summary}</p>}
            {o.share_amount > 0 && <p className="text-xs text-mr-muted mt-3 tabular">{o.shares_total} parts de {fcfa(o.share_amount)}</p>}
          </div></Link></li>))}</ul>
      )}
    </div>
  );
}
